export default __webpack_public_path__ + "static/media/oxo_standup.428b97d1.png";